import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';

import { CommentDialog } from '../../../components/common/comment-dialog/CommentDialog';
import { aspirationCommentDialogConfig } from '../utils/comment-dialog-config';
import { AspirationFormValues } from '../utils/schema';

type Props = {
  setValue: UseFormSetValue<AspirationFormValues>;
  getValues: UseFormGetValues<AspirationFormValues>;
  setShowAddComments: (value: boolean) => void;
  initialSelectedCommentType?: string;
  onClose?: () => void;
};

export const AddCommentsDialog = ({
  setShowAddComments,
  setValue,
  getValues,
  initialSelectedCommentType,
  onClose,
}: Props) => {
  const handleSetValue = (fieldName: string, value: string) => {
    setValue(fieldName as keyof AspirationFormValues, value);
  };

  const handleGetValue = (fieldName: string) => {
    const value = getValues(fieldName as keyof AspirationFormValues);
    return typeof value === 'string' ? value : value?.toString() || null;
  };

  const handleClose = () => {
    setShowAddComments(false);
    onClose?.();
  };

  return (
    <CommentDialog
      config={aspirationCommentDialogConfig}
      setValue={handleSetValue}
      getValue={handleGetValue}
      onClose={handleClose}
      initialSelectedCommentType={initialSelectedCommentType}
    />
  );
};
